import angular from 'angular';

export default angular.module('settings', ['ui.router', 'ngResource']);
